import { render, staticRenderFns } from "./AuthConfig.vue?vue&type=template&id=4e2545ee&scoped=true"
import script from "./AuthConfig.vue?vue&type=script&lang=js"
export * from "./AuthConfig.vue?vue&type=script&lang=js"
import style0 from "./AuthConfig.vue?vue&type=style&index=0&id=4e2545ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2545ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e2545ee')) {
      api.createRecord('4e2545ee', component.options)
    } else {
      api.reload('4e2545ee', component.options)
    }
    module.hot.accept("./AuthConfig.vue?vue&type=template&id=4e2545ee&scoped=true", function () {
      api.rerender('4e2545ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/data/AuthConfig.vue"
export default component.exports